
const data = [
    
    {  image1: './images/1.jpg' },
    {  image2: './images/2.png' },
    {  image3: './images/3.png' },
    {  image4: './images/4.png' }
];

export default data;